package org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.update_furniture.UpdateFurnitureModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.UpdateFurnitureRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

import org.hs_soft.runmynesto.domain.config.Errors


class UpdateFurnitureRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): UpdateFurnitureRepository
{
    override suspend fun updateFurniture(
        id: String?,
        height: Int?,
        positionLeft: Int?,
        positionTop: Int?,
        rotationDeg: Int?,
        width: Int?,
        caption: String?,
        componentColor: String?
    ): UpdateFurnitureModel {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
                mutation updateFurniture(${'$'}fields: [UpdateFurnitureFields]!) {
                  cashAssist {
                    updateFurniture(fields:${'$'}fields) {
                      ...furnitureFragment
                      ${ApiUtils.Field.__typename}
                    }
                    ${ApiUtils.Field.__typename}
                  }
                }

                fragment furnitureFragment on Furniture {
                  ${ApiUtils.Field.id}
                  ${ApiUtils.Field.mod_ver}
                  ${ApiUtils.Field.projectId}
                  ${ApiUtils.Field.floorId}
                  ${ApiUtils.Field.roomId}
                  ${ApiUtils.Field.objectType}
                  ${ApiUtils.Field.objectKind}
                  ${ApiUtils.Field.caption}
                  ${ApiUtils.Field.componentColor}
                  ${ApiUtils.Field.positionTop}
                  ${ApiUtils.Field.positionLeft}
                  ${ApiUtils.Field.rotationDeg}
                  ${ApiUtils.Field.height}
                  ${ApiUtils.Field.width}
                  ${ApiUtils.Field.shape}
                  ${ApiUtils.Field.__typename}
                }

            """.trimIndent())

            putJsonObject("variables") {
                putJsonObject("fields"){
                    put("id", id)
                    if (height!=null)
                        put("height", height)
                    if (positionLeft!=null)
                        put("positionLeft", positionLeft)
                    if (positionTop!=null)
                        put("positionTop", positionTop)
                    if (rotationDeg!=null)
                        put("rotationDeg", rotationDeg)
                    if (width!=null)
                        put("width", width)
                    if (height!=null)
                        put("height", height)
                    if (componentColor!=null)
                        put("componentColor",componentColor)
                    if (caption!=null)
                        put("caption",caption)


                }
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)

        }

    }




}